export default __webpack_public_path__ + "static/media/footer.32f42a1c.jpg";